// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JIvuixmhkwX4UIKJKWXy {
  text-overflow: ellipsis;
  flex-direction: column;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.JIvuixmhkwX4UIKJKWXy h2 {
  width: 100%;
  text-align: center;
}

.nlP0Egdm4XpCrrMjyzwg {
  color: var(--place-color);
  font-weight: bolder;
}

.XAcyOKeoXAn7J3CcXRpS {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: var(--step-0);
  gap: 1rem;
  width: 100%;
}

.ZXWehuBYrdXtGQSSB5AD {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 150px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.QgRHThElDlfeXmaPQyTA {
  display: flex;
  flex-grow: 1;
  align-items: center;
  word-wrap: break-word;
  padding-left: 1rem;
}

.oaTLCXwTJsTKs6DlUYZv {
  padding-right: 1rem;
  list-style-type: "\\f04b";
  font-size: 16px;
  margin-left: 16px;
  padding-left: 8px;
  margin-bottom: 4px;
}

.oaTLCXwTJsTKs6DlUYZv::marker {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: mediumorchid;
}

.VyrNxQAVh9XhonubaPiI {
  text-decoration: none;
  font-size: 1rem;
  color: #b156c8;
  transition: color 0.3s ease;
}

.VyrNxQAVh9XhonubaPiI:hover {
  text-decoration: underline;
}

.g2ch1k0YxbTVHYL2DqHE {
  list-style-type: "\\f133";
  font-size: 16px;
  margin-right: 1rem;
  color: var(--md-grey-colo);
}

.g2ch1k0YxbTVHYL2DqHE::marker {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: var(--date-color);
}

@keyframes mrmfjmG6qihlDt7ZRdbo {
  0% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.6;
  }
}
.oBM358QQx_6DrnHvx7Ww {
  animation: mrmfjmG6qihlDt7ZRdbo 0.8s ease-in-out infinite;
  height: 12rem;
}

@media (max-width: 768px) {
  .XAcyOKeoXAn7J3CcXRpS {
    flex-direction: column;
    align-items: flex-start;
  }

  .QgRHThElDlfeXmaPQyTA {
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage/components/MeetingsSection.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB,EAAE,gBAAgB;EACvC,wBAAwB,EAAE,mCAAmC;AAC/D;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,yDAAkD;EAClD,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".cityMeetingSection {\n  text-overflow: ellipsis;\n  flex-direction: column;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  scrollbar-width: none; /* For Firefox */\n  -ms-overflow-style: none; /* For Internet Explorer and Edge */\n}\n\n.cityMeetingSection h2 {\n  width: 100%;\n  text-align: center;\n}\n\n.displayText {\n  color: var(--place-color);\n  font-weight: bolder;\n}\n\n.meetingRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  font-size: var(--step-0);\n  gap: 1rem;\n  width: 100%;\n}\n\n.dateIcon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 150px;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.linkRow {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  word-wrap: break-word;\n  padding-left: 1rem;\n}\n\n.more {\n  padding-right: 1rem;\n  list-style-type: \"\\f04b\";\n  font-size: 16px;\n  margin-left: 16px;\n  padding-left: 8px;\n  margin-bottom: 4px;\n}\n\n.more::marker {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: mediumorchid;\n}\n\n.linkNoUnderline {\n  text-decoration: none;\n  font-size: 1rem;\n  color: #b156c8;\n  transition: color 0.3s ease;\n}\n\n.linkNoUnderline:hover {\n  text-decoration: underline;\n}\n\n.date {\n  list-style-type: \"\\f133\";\n  font-size: 16px;\n  margin-right: 1rem;\n  color: var(--md-grey-colo);\n}\n\n.date::marker {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: var(--date-color);\n}\n\n@keyframes skeletonPulse {\n  0% {\n    opacity: 0.6;\n  }\n  70% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n.meetingSectionSkeleton {\n  animation: skeletonPulse 0.8s ease-in-out infinite;\n  height: 12rem;\n}\n\n@media (max-width: 768px) {\n  .meetingRow {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .linkRow {\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cityMeetingSection": `JIvuixmhkwX4UIKJKWXy`,
	"displayText": `nlP0Egdm4XpCrrMjyzwg`,
	"meetingRow": `XAcyOKeoXAn7J3CcXRpS`,
	"dateIcon": `ZXWehuBYrdXtGQSSB5AD`,
	"linkRow": `QgRHThElDlfeXmaPQyTA`,
	"more": `oaTLCXwTJsTKs6DlUYZv`,
	"linkNoUnderline": `VyrNxQAVh9XhonubaPiI`,
	"date": `g2ch1k0YxbTVHYL2DqHE`,
	"meetingSectionSkeleton": `oBM358QQx_6DrnHvx7Ww`,
	"skeletonPulse": `mrmfjmG6qihlDt7ZRdbo`
};
export default ___CSS_LOADER_EXPORT___;
